<!-- src/views/auth/login.vue -->
<template>
  <form @submit.prevent="handleLogin">
    <section class="container d-flex justify-content-center align-items-center">
      <div class="card w-50">
        <div class="card-body pb-5">
          <h2 class="text-center my-3">{{ $t('page.auth.login.title') }}</h2>
          <div class="col mb-3">
            <label for="username">{{ $t('page.auth.login.inputs.username') }}</label>
            <input class="form-control" id="username" type="text" v-model="formData.username" required :placeholder="$t('page.auth.login.inputs.usernamePlace')" />
          </div>
          <div class="col">
            <label for="password">{{ $t('page.auth.login.inputs.password') }}</label>
            <input class="form-control" id="password" type="password" v-model="formData.password" required :placeholder="$t('page.auth.login.inputs.passwordPlace')" />
          </div>
        </div>
        <div class="card-footer text-center">
          <button class="btn btn-primary" type="submit">{{ $t('common.submit') }}</button>
        </div>
      </div>
    </section>
  </form>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/authStore";

const router = useRouter();
const authStore = useAuthStore();

const formData = ref({
  username: '',
  password: '',
});

const handleLogin = async () => {
  try {
    await authStore.login(formData.value);
    router.push({ name: "dashboard" });
  } catch (error) {
    console.error(error.response?.data?.message);
  }
};

onMounted(() => {
  if (authStore.isAuthenticated) {
    router.push({ name: "dashboard" });
  }
});
</script>

<style scoped></style>
